import vars from "../helpers";

let swiperGalleryPopup = null;

let $main = null;
let $closeBtn = null;
let $openBtn = null;
let $swiper = null;

function open() {
	$main.addClass('is-show-gallery-popup');
	vars.$html.addClass('is-lock-scroll');

	let idGalleryImage = $(this)[0].dataset.id;

	swiperGalleryPopup.slideToLoop(idGalleryImage);

	setTimeout(() => {
		$main.addClass('is-open-gallery-popup');
	}, 200);
}

function close() {
	if ($main) {
		$main.removeClass('is-open-gallery-popup is-not-transition');
		vars.$html.removeClass('is-lock-scroll');

		setTimeout(() => {
			$main.removeClass('is-show-gallery-popup');
		}, 500);
	}
}

function init(container) {
	$main = $(container).find('.main');
	$closeBtn = $(container).find('.js-close-gallery-popup');
	$openBtn = $(container).find('.gallery-swiper__item');
	$swiper = $(container).find('.js-swiper-gallery-popup')[0];

	$openBtn.on('click', open);
	$closeBtn.on('click', close);

	swiperGalleryPopup = new Swiper($swiper, {
		direction: 'horizontal',
		preloadImages: false,
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 2,
			enabled: true,
		},
		grabCursor: true,
		slidesPerView: 1,
		speed: 800,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: '.gallery-popup-swiper-arrow__right',
			prevEl: '.gallery-popup-swiper-arrow__left',
		}
	});
}

function destroy() {
	$swiper = null;

	if ($openBtn) {
		$openBtn.off('click', open);
		$openBtn = null;
	}

	if ($closeBtn) {
		$closeBtn.off('click', close);
		$closeBtn = null;
	}

	if (swiperGalleryPopup) {
		swiperGalleryPopup.destroy();

		swiperGalleryPopup = null;
	}
}

export default {
	init,
	destroy,
}
